// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Lesotho from '../_raw/flag/icon_flag_lesotho.png';

export default () => <img src={Lesotho} alt="Lesotho" />;
